module.exports = __webpack_public_path__ + "static/media/hero.b0ba2c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/hero.jpg
// module id = 970
// module chunks = 0